export default __webpack_public_path__ + "static/media/ChartHiddenIcon.6ab81632.svg";